var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    staticClass: "consignment",
    on: {
      "click": _vm.toggle
    }
  }, [_c('v-card-title', [_vm._v("위탁판매(+4,000원)")]), _c('v-checkbox', _vm._b({
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: _vm.isConsigned,
      callback: function ($$v) {
        _vm.isConsigned = $$v;
      },
      expression: "isConsigned"
    }
  }, 'v-checkbox', _vm.attrs_input2, false))], 1), _c('p', {
    staticClass: "consignment-hint"
  }, [_vm._v("위탁판매 시 배송대행비 및 택배비는 주문 건별 즉시 결제입니다.")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }